module.exports = __webpack_public_path__ + "img/purple-circle-table-3.a99f84ac.png";